import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import { Text, Title } from '@paygreen/paygreen-ui';
import { ModalForm, Message } from '../../../../components';
import CarbonEmissionStatusList from './CarbonEmissionStatusList';
import CarbonEqTypesList from './CarbonEqTypesList';

const CarbonExplanationModal = ({ t, isOpen }) => (
    <ModalForm
        modalTitle={t('offsets.explanationModal.modalTitle')}
        blockWidth="xl"
        paddingLateral="md"
        paddingBottom="md"
        hasCloseCross={true}
        isOpen={isOpen}
    >
        <Title htmlTag="h4" marginBottom="xs">
            {t('offsets.explanationModal.carbonEq.title')}
        </Title>

        <CarbonEqTypesList />

        <Message type="success" paddingLateral="sm" marginTop="md">
            <Text textSize="xs" colorPallet="status" colorStatus="success">
                <Trans i18nKey="offsets.explanationModal.calculationContributionMessage.calculationText">
                    ...
                    <Text
                        textSize="xs"
                        colorPallet="status"
                        colorStatus="success"
                        htmlTag="strong"
                    >
                        {{
                            minus: t(
                                'offsets.explanationModal.calculationContributionMessage.minus',
                            ),
                        }}
                    </Text>
                    ...
                </Trans>
            </Text>
        </Message>

        <Title htmlTag="h4" marginTop="sm">
            {t('offsets.explanationModal.status.title')}
        </Title>

        <Text textSize="xs" marginTop="xs" colorWab="grey50">
            {t('offsets.explanationModal.status.intro')}
        </Text>

        <CarbonEmissionStatusList />

        <Title htmlTag="h4" marginTop="sm">
            {t('offsets.explanationModal.price.title')}
        </Title>

        <Text textSize="xs" colorWab="grey50" marginTop="xs">
            {t('offsets.explanationModal.price.intro')}
        </Text>

        <Text textSize="xs" colorWab="grey50" marginTop="xs">
            <Trans i18nKey="offsets.explanationModal.price.case">
                ...
                <Text textSize="xs" htmlTag="strong" colorWab="grey50">
                    {{
                        onGoingCase: t(
                            'offsets.explanationModal.price.onGoingCase',
                        ),
                    }}
                </Text>
                ...
                <Text
                    textSize="xs"
                    htmlTag="strong"
                    colorPallet="status"
                    colorStatus="warning"
                >
                    {{
                        toPurchaseCase: t(
                            'offsets.explanationModal.price.toPurchaseCase',
                        ),
                    }}
                </Text>
            </Trans>
        </Text>

        <Message type="default" paddingLateral="sm" marginTop="md">
            <Text textSize="xs" colorPallet="status">
                <Trans i18nKey="offsets.explanationModal.calculationProjectMessage.calculationProjectText">
                    ...
                    <Text textSize="xs" colorPallet="status" htmlTag="strong">
                        {{
                            carbonProject: t(
                                'offsets.explanationModal.calculationProjectMessage.carbonProject',
                            ),
                        }}
                    </Text>
                    ...
                    <Text textSize="xs" colorPallet="status" htmlTag="strong">
                        {{
                            carbonPrice: t(
                                'offsets.explanationModal.calculationProjectMessage.carbonPrice',
                            ),
                        }}
                    </Text>
                    ...
                </Trans>
            </Text>
        </Message>

        <Text textSize="xs" colorWab="grey50" marginTop="xs">
            <Trans i18nKey="offsets.explanationModal.purchasedEnd.endText">
                ...
                <Text textSize="xs" htmlTag="strong" colorPallet="theme">
                    {{
                        purchasedCase: t(
                            'offsets.explanationModal.purchasedEnd.purchasedCase',
                        ),
                    }}
                </Text>
                ...
            </Trans>
        </Text>
    </ModalForm>
);

CarbonExplanationModal.propTypes = {
    /**
     * @description isOpen is automatically received from ModalControl parent
     */
    isOpen: PropTypes.bool,
};

CarbonExplanationModal.defaultProps = {
    isOpen: false,
};

export default withTranslation('common')(CarbonExplanationModal);
